export function noNumber(value) {
  if (value === '') {
    return true
  }
  return /^([^0-9]*)$/i.test(value) ? true : false
}

export function onlyAlphaNumSpace(value) {
  if (value === '') {
    return true
  }
  return /^[a-z\d\-_\s]+$/i.test(value) ? true : false
}

export function minOneNumber(value) {
  if (value === '') {
    return true
  }
  return /.*[0-9].*/.test(value) ? true : false
}
export function minOneAlpha(value) {
  if (value === '') {
    return true
  }
  return /.*[a-z].*/i.test(value) ? true : false
}

export function noSpecialCharacters(value) {
  if (value === '') {
    return true
  }
  return /[@#$%^&*{}|<>]/g.test(value) ? false : true
}

export function noAngleBrackets(value) {
  if (value === '') {
    return true
  }
  return /[<>]/g.test(value) ? false : true
}

export function phoneNumber(value) {
  if (value === '') {
    return true
  }
  return /[+-/()]/g.test(value) ? true : false
}

export function addressValidation(value) {
  if (value === '') {
    return true
  }
  let arr = value.split(' ')

  return arr.length >= 2 && arr[arr.length - 1] !== '0'
}

export function noSingleZero(value) {
  if (value === '') {
    return true
  }

  return value !== 0 && value !== '0'
}
